import { render, staticRenderFns } from "./supportModalChatWithousAuth.vue?vue&type=template&id=15a41265&scoped=true&"
import script from "./supportModalChatWithousAuth.vue?vue&type=script&lang=js&"
export * from "./supportModalChatWithousAuth.vue?vue&type=script&lang=js&"
import style0 from "./supportModalChatWithousAuth.vue?vue&type=style&index=0&id=15a41265&lang=sass&rel=stylesheets%2Fsass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a41265",
  null
  
)

export default component.exports